import { AxiosPromise } from 'axios';
import api from '~/services/api';
import { JSONInvoiceItem } from '~/types/InvoiceItem';
import buildInvoiceItemsQueryString from './buildInvoiceItemsQueryString';

export type JSONExportInvoiceItemsResponse = {
  links: {
    csv_export: string;
  };
};

export type JSONSearchInvoiceItemsResponse = {
  data: {
    count: number;
    results: JSONInvoiceItem[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    previous: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    next: any;
  };
};

export function exportInvoiceItems(filter: {
  startDate?: string;
  endDate?: string;
  isPaid?: boolean;
  invoiceItemType?: string;
  shopApp?: string;
  carrierAccountId?: string;
}): AxiosPromise<JSONExportInvoiceItemsResponse> {
  return api.request({
    url: '/billing/invoicing/export',
    method: 'POST',
    data: {
      filter: {
        start_date: filter.startDate,
        end_date: filter.endDate,
        is_paid: filter.isPaid,
        invoice_item_type: filter.invoiceItemType,
        shop_app: filter.shopApp,
        carrier_account_id: filter.carrierAccountId,
      },
    },
  });
}

export function searchInvoiceItems(
  pageNumber = 1,
  pageSize = 25,
  searchQuery = '',
  startDate?: string,
  endDate?: string,
  paymentStatus?: boolean,
  invoiceItemType?: string,
  shopApp?: string,
  carrierAccountId?: string,
): AxiosPromise<JSONSearchInvoiceItemsResponse> {
  const filters = {
    start_date: startDate,
    end_date: endDate,
    is_paid: paymentStatus,
    invoice_item_type: invoiceItemType,
    shop_app: shopApp,
    carrier_account_id: carrierAccountId,
  };
  const page = {
    number: pageNumber,
    limit: pageSize,
  };

  const filtersQueryString = buildInvoiceItemsQueryString('filter', filters);

  const pageQueryString = buildInvoiceItemsQueryString('page', page);

  const searchQueryString = `&q=${searchQuery}`;

  return api.request({
    url: `/v1/invoice_items/search?expand[]=transaction&expand[]=order&expand[]=invoice${filtersQueryString}${pageQueryString}${searchQueryString}`,
    method: 'GET',
  });
}
